export default __webpack_public_path__ + "static/media/4.bf4416e0.jpg";